const icons = {
  channel: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-target-arrow"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
      <path d="M12 7a5 5 0 1 0 5 5" />
      <path d="M13 3.055a9 9 0 1 0 7.941 7.945" />
      <path d="M15 6v3h3l3 -3h-3v-3z" />
      <path d="M15 9l-3 3" />
    </svg>
  ),
  rateCard: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-wave-saw-tool"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 12h5l4 8v-16l4 8h5" />
    </svg>
  ),
  blackoutTime: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-clock-fill" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
    </svg>
  ),
  connection: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-share"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M6 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
      <path d="M18 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
      <path d="M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
      <path d="M8.7 10.7l6.6 -3.4"></path>
      <path d="M8.7 13.3l6.6 3.4"></path>
    </svg>
  ),
  cost: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-coins"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M9 14c0 1.657 2.686 3 6 3s6 -1.343 6 -3s-2.686 -3 -6 -3s-6 1.343 -6 3z"></path>
      <path d="M9 14v4c0 1.656 2.686 3 6 3s6 -1.344 6 -3v-4"></path>
      <path d="M3 6c0 1.072 1.144 2.062 3 2.598s4.144 .536 6 0c1.856 -.536 3 -1.526 3 -2.598c0 -1.072 -1.144 -2.062 -3 -2.598s-4.144 -.536 -6 0c-1.856 .536 -3 1.526 -3 2.598z"></path>
      <path d="M3 6v10c0 .888 .772 1.45 2 2"></path>
      <path d="M3 11c0 .888 .772 1.45 2 2"></path>
    </svg>
  ),
  tax: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-receipt-tax"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M9 14l6 -6"></path>
      <circle cx="9.5" cy="8.5" r=".5" fill="currentColor"></circle>
      <circle cx="14.5" cy="13.5" r=".5" fill="currentColor"></circle>
      <path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"></path>
    </svg>
  ),
  order: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-garden-cart"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M17.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"></path>
      <path d="M6 8v11a1 1 0 0 0 1.806 .591l3.694 -5.091v.055"></path>
      <path d="M6 8h15l-3.5 7l-7.1 -.747a4 4 0 0 1 -3.296 -2.493l-2.853 -7.13a1 1 0 0 0 -.928 -.63h-1.323"></path>
    </svg>
  ),
  defaultConnection: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-topology-star-2"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M14 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"></path>
      <path d="M14 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"></path>
      <path d="M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"></path>
      <path d="M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"></path>
      <path d="M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"></path>
      <path d="M6 12h4"></path>
      <path d="M14 12h4"></path>
      <path d="M12 6v4"></path>
      <path d="M12 14v4"></path>
    </svg>
  ),
  masks: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-masks-theater"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M13.192 9h6.616a2 2 0 0 1 1.992 2.183l-.567 6.182a4 4 0 0 1 -3.983 3.635h-1.5a4 4 0 0 1 -3.983 -3.635l-.567 -6.182a2 2 0 0 1 1.992 -2.183z" />
      <path d="M15 13h.01" />
      <path d="M18 13h.01" />
      <path d="M15 16.5c1 .667 2 .667 3 0" />
      <path d="M8.632 15.982a4.037 4.037 0 0 1 -.382 .018h-1.5a4 4 0 0 1 -3.983 -3.635l-.567 -6.182a2 2 0 0 1 1.992 -2.183h6.616a2 2 0 0 1 2 2" />
      <path d="M6 8h.01" />
      <path d="M9 8h.01" />
      <path d="M6 12c.764 -.51 1.528 -.63 2.291 -.36" />
    </svg>
  ),
  owners: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-people-fill" viewBox="0 0 16 16">
      <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    </svg>
  ),
  opt_out_message: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="currentColor"
      className="bi bi-chat-left-quote"
      strokeWidth=".4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 16 16"
    >
      <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
      <path d="M7.066 4.76A1.665 1.665 0 0 0 4 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112zm4 0A1.665 1.665 0 0 0 8 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112z" />
    </svg>
  ),
  list: <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-list-numbers" width="20"
  height="20" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
  strokeLinecap="round" strokeLinejoin="round">
<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
<path d="M11 6h9"></path>
<path d="M11 12h9"></path>
<path d="M12 18h8"></path>
<path d="M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4"></path>
<path d="M6 10v-6l-2 2"></path>
</svg>,
create_contact : <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-person-rolodex" viewBox="0 0 16 16">
<path d="M8 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/>
<path d="M1 1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h.5a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H6.707L6 1.293A1 1 0 0 0 5.293 1zm0 1h4.293L6 2.707A1 1 0 0 0 6.707 3H15v10h-.085a1.5 1.5 0 0 0-2.4-.63C11.885 11.223 10.554 10 8 10c-2.555 0-3.886 1.224-4.514 2.37a1.5 1.5 0 0 0-2.4.63H1z"/>
</svg>
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const configurations = {
  id: "configs",
  title: "Configurations",
  type: "group",
  role: [1, 2],
  children: [
    {
      id: "/user/list",
      title: "User Management",
      type: "item",
      url: "/user/list",
      icon: icons.owners,
      role: [1],
      breadcrumbs: false,
    },
    {
      id: "/api-user/list",
      title: "User Management",
      type: "item",
      url: "/api-user/list",
      icon: icons.owners,
      role: [2],
      breadcrumbs: false,
    },
    {
      id: "/number-base",
      title: "Number Base",
      type: "item",
      url: "/number-base",
      icon: icons.create_contact,
      role: [2],
      breadcrumbs: false,
    },
    {
      id: "/mask/list",
      title: "Masks",
      type: "item",
      url: "/mask/list",
      icon: icons.masks,
      role: [1],
      breadcrumbs: false,
    },
    {
      id: "/config/channel",
      title: "Channels",
      type: "item",
      url: "/config/channel",
      icon: icons.channel,
      role: [1],
      breadcrumbs: false,
    },
    {
      id: "/config/rate-card",
      title: "Rate Cards",
      type: "item",
      url: "/config/rate-card",
      icon: icons.rateCard,
      role: [1],
      breadcrumbs: false,
    },
    {
      id: "/config/blackout-time",
      title: "Blackout Time",
      type: "item",
      url: "/config/blackout-time",
      icon: icons.blackoutTime,
      role: [1],
      breadcrumbs: false,
    },
    // {
    //   id: "/config/opt-out-message",
    //   title: "Opt Out Message",
    //   type: "item",
    //   url: "/config/opt-out-message",
    //   icon: icons.opt_out_message,
    //   role: [1],
    //   breadcrumbs: false,
    // },
    // {
    //     id: '/config/cost-management',
    //     title: 'Per Message Cost Management',
    //     type: 'item',
    //     url: '/config/cost-management',
    //     icon: icons.cost,
    //     role: [],
    //     breadcrumbs: false
    // },
    {
      id: "/config/tax-management",
      title: "Tax Management",
      type: "item",
      url: "/config/tax-management",
      icon: icons.tax,
      role: [1],
      breadcrumbs: false,
    },
    // {
    //     id: '/config/order-management',
    //     title: 'Transaction Priority Order Management',
    //     type: 'item',
    //     url: '/config/order-management',
    //     icon: icons.order,
    //     role: [],
    //     breadcrumbs: false
    // },
  ],
};

export default configurations;
